/** @jsxImportSource @emotion/react */
import React from "react";
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import DeleteIcon from "@material-ui/icons/Delete";
import Fade from "@material-ui/core/Grow";
import LinearProgress from "@material-ui/core/LinearProgress";
import Masonry from "components/tools/MasonryLayout";

const Wrap = styled.div`
  ${props => props.disabled && "opacity:0.5; pointer-events:none;"}
  margin: 0px;
  position: relative;
`;

const CollageWrap = styled.div`
  ${p => p.selected && "outline: 2px solid #a8bb43;"}
  background: #fff2;
  min-height: 70px;
  width: 157px;
  position: relative;
  .overlay {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9;
    top: 0;
    left: 0;
    right: 0;
    height: 16px;
    background: #80808075;
    font-size: 12px;
  }

  img {
    width: 100%;
  }
`;

const DeleteButton = styled(DeleteIcon)`
  transition: opacity 0.2s ease-in-out;
  position: absolute;
  right: 1px;
  bottom: 1px;
  padding: 2px;
  color: white;
  height: 24px;
  width: 24px;
  opacity: 0.5;
  z-index: 99;
  cursor: pointer;
  background: #0008;
  border-radius: 50%;
  :hover {
    opacity: 1;
  }
`;

const Collage = ({ collage, onRemove, onSelect, selected, isAdmin }) => {
  const { id, title, preview } = collage;
  return (
    <CollageWrap
      selected={selected}
      onClick={e => onSelect && onSelect(collage)}
    >
      {preview && <img src={preview} alt="Collage"/>}
        <React.Fragment>
          <div className="overlay">{title}</div>
          {isAdmin && (
            <DeleteButton
              onClick={e => {
                e.stopPropagation();
                onRemove(id);
              }}
            />
          )}
        </React.Fragment>
    </CollageWrap>
  );
};

const Collages = ({
  collages,
  onRemove,
  onSelect,
  isLoading,
  selected,
  isAdmin
}) => {
  const filteredCollages = collages.filter(collage => {
    if (!isAdmin && !collage.preview) {
      return false;
    }
    return true;
  })
  return (
    <Wrap disabled={isLoading}>
      <Fade in={isLoading} unmountOnExit>
        <LinearProgress
          color="secondary"
          css={css`
            position: absolute;
            top: -4px;
            left: 0px;
            width: 100%;
            height: 2px;
          `}
        />
      </Fade>

      <Masonry columns={2} gap={5}>
        {filteredCollages.map(collage => (
          <Collage
            key={collage.id}
            isAdmin={isAdmin}
            collage={collage}
            selected={collage.id === selected}
            onRemove={onRemove}
            onSelect={onSelect}
          />
        ))}
      </Masonry>
    </Wrap>
  );
};

export default Collages;
